<header class="page-header">
  <h2 class="page-heading">{{ 'pages.user-create.headerTitle' | translate }}</h2>
</header>
<h3 class="userRecordsLink">
  <a class="bciti-inline-button" routerLink="/user-records" routerLinkActive="active">
    <span class="icon-arrow-left"></span>
    <label>{{ 'pages.user-create.returnToUserSearch' | translate }}</label>
  </a>
</h3>
<hr/>
<h3 class="sub-heading">{{ 'pages.user-create.subTitle' | translate }}</h3>
<div class="card" *ngIf="profileLoaded">
  <form [formGroup]="profileForm" (keyup.enter)="submit.focus(); save()">
    <div class="col-wrap">
      <div class="col">
        <app-form-profile-picture 
        *ngIf="displayField(profileField.PICTURE)"
          label="{{'pages.profile.profilePictureButton' | translate }}"
          formControlName="picture"
          data-cy="picture">
          <app-form-error *ngIf="picture.touched && picture.hasError('required')">
            {{'common.errors.invalidProfilePicture' | translate }}
          </app-form-error>
        </app-form-profile-picture>
        <app-form-input 
          *ngIf="displayField(profileField.FIRSTNAME)"
          label="{{'common.fields.firstName' | translate }}" 
          formControlName="firstName"
          data-cy="firstName">
          <app-form-error *ngIf="firstName.touched && firstName.hasError('required')">
            {{'common.errors.invalidFirstName' | translate }}
          </app-form-error>
        </app-form-input>
        <app-form-input 
          *ngIf="displayField(profileField.LASTNAME)"
          label="{{'common.fields.lastName' | translate }}" 
          formControlName="lastName" 
          data-cy="lastName">
          <app-form-error *ngIf="lastName.touched && lastName.hasError('required')">
            {{'common.errors.invalidLastName' | translate }}
          </app-form-error>
        </app-form-input>
        <div class="radio-wrap" *ngIf="displayField(profileField.SEX)">
          <label>{{'common.fields.sex' | translate }}</label>
          <app-form-radio
            val="male"
            formControlName="sex" 
            data-cy="male">
            {{'pages.profile.male' | translate }}
          </app-form-radio>
          <app-form-radio
            val="female"
            formControlName="sex"
            data-cy="female">
            {{'pages.profile.female' | translate }}
          </app-form-radio>
          <app-form-radio
            *ngIf="orgTag !== 'BROSSARD'"
            val="other"
            formControlName="sex"
            data-cy="other">
            {{'pages.profile.other' | translate }}
          </app-form-radio>
          <app-form-error *ngIf="sex.touched && sex.hasError('required')">
            {{'pages.profile.errors.invalidSex' | translate }}
          </app-form-error>
        </div>
        <app-form-datepicker
          *ngIf="displayField(profileField.BIRTHDATE)"
          label="{{'common.fields.birthdate' | translate }}" 
          formControlName="birthDate" 
          data-cy="birthDate">
          <app-form-error *ngIf="birthDate.touched && birthDate.hasError('validateDateIsInPast')">
            {{'common.errors.birthDateFuture' | translate }}
          </app-form-error>
        </app-form-datepicker>
      </div>
      <div class="col">
        <app-form-input
          *ngIf="displayField(profileField.PHONE)"
          appPhoneMask
          type="phone" 
          label="{{'common.fields.mainPhone' | translate}}" 
          formControlName="phone"
          data-cy="phone">
          <app-form-error *ngIf="phone.touched && phone.hasError('required')">
            {{'pages.profile.errors.invalidPhoneNumber' | translate }}
          </app-form-error>
        </app-form-input>
        <div class="phone-ext" *ngIf="displayField(profileField.SECPHONE)">
          <app-form-input 
            appPhoneMask
            type="phone" 
            label="{{ 'common.fields.secondaryPhone' | translate }}" 
            formControlName="secPhone"
            data-cy="secPhone">
          </app-form-input>
          <app-form-input 
            label="{{ 'common.fields.extPhone' | translate }}" 
            formControlName="secPhoneExt"
            data-cy="secPhoneExt">
          </app-form-input>
        </div>
        <app-form-input 
          *ngIf="displayField(profileField.CELLPHONE)"
          appPhoneMask
          type="phone" 
          label="{{ 'common.fields.cellphone' | translate }}" 
          formControlName="cellPhone"
          data-cy="cellPhone">
        </app-form-input>
        <app-form-input
          class="span"
          type="email" 
          label="{{ 'common.fields.idEmail' | translate }}" 
          formControlName="email" 
          data-cy="email">
          <app-form-error *ngIf="email.touched && (email.hasError('email') || email.hasError('required'))">
            {{ 'common.errors.invalidEmail' | translate }}
          </app-form-error>
        </app-form-input>
      </div>
    </div>
  </form>

  <!-- Address section (created as a Residence once the user is saved) -->
  <div class="addresses-section">
    <h4 class="section-title">{{ 'pages.profile.mainAddress' | translate }}</h4>
    <div class="addresses-grid" *ngIf="pendingAddress">
      <div class="address-card">
        <div class="address-card-header">
          <div class="address-name-row">
            <span class="address-name">{{ pendingAddress.city | uppercase }}</span>
          </div>
          <div class="address-header-right">
            <div class="address-badges">
              <span class="badge badge--primary">
                <i class="icon-home"></i>
                {{ 'pages.profile.addresses.primaryResidence' | translate }}
              </span>
              <span *ngIf="pendingAddressSubType === 'RESIDENT'" class="badge badge--subtype-resident">
                {{ 'pages.residences.subType.resident' | translate }}
              </span>
              <span *ngIf="pendingAddressSubType === 'NONRESIDENT'" class="badge badge--subtype-nonresident">
                {{ 'pages.residences.subType.nonResident' | translate }}
              </span>
            </div>
          </div>
        </div>

        <div class="address-detail">
          <i class="icon-map address-pin"></i>
          <div class="address-lines">
            <span>{{ pendingAddress.unit ? '#' + pendingAddress.unit + ' ' : '' }}{{ pendingAddress.number }} {{ pendingAddress.streetName || pendingAddress.street }}</span>
            <span>{{ pendingAddress.city }}{{ pendingAddress.province ? ' (' + pendingAddress.province + ')' : '' }}</span>
            <span>{{ pendingAddress.postCode }}</span>
          </div>
        </div>

        <div class="address-card-actions">
          <div class="actions-left"></div>
          <button type="button" class="delete-address-btn" (click)="removePendingAddress()">
            <i class="icon-trash-bin"></i>
            {{ 'pages.profile.addresses.delete' | translate }}
          </button>
        </div>
      </div>
    </div>
    <button type="button" class="add-address-btn" *ngIf="!pendingAddress" (click)="openAddAddressDialog()">
      <span>+</span> {{ 'pages.profile.addresses.addAddress' | translate }}
    </button>
  </div>

  <footer>
    <button
      #submit
      class="bciti-button bciti-button--blue"
      [disabled]="loading"
      data-cy="save-button"
      (click)="save()">
      <span *ngIf="!loading">{{ 'pages.profile.save' | translate }}</span>
      <div class="loading-spinner" *ngIf="loading">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="19">
        </mat-progress-spinner>
      </div>
    </button>
  </footer>
</div>
